'use client';
import PTAdvertisement from './pt-advertisement';
import clsx from 'clsx';
import { useRef } from 'react';

export interface PTAdvertisementWrapperProps {
	className?: string;
	ipAddress?: string;
	pageId: number;
	place: number;
	zoneId: string;
	isProd?: boolean;
}

const PTAdvertisementWrapper = (props: PTAdvertisementWrapperProps) => {
	const adRef = useRef<HTMLDivElement | null>(null);

	const { className, pageId, place, zoneId, isProd } = props;

	const placementId = `${zoneId}_${pageId}_${place}`;

	const classes = clsx(
		'!size-full min-[500px]:min-w-[224px] min-[500px]:max-w-[286px] rounded-xl',
		{
			'border border-solid bg-gray-400 text-white': !isProd
		},
		className
	);

	return (
		<div id={placementId} className={classes} ref={adRef}>
			<PTAdvertisement {...props} adRef={adRef} />
		</div>
	);
};

export default PTAdvertisementWrapper;
